import React from 'react';
import './Hero.css';

const Hero = () => {
    const images = [
        '/images/1.jpg',
        '/images/2.jpg',
        '/images/3.jpg',
        '/images/4.jpg'
    ];

    const scrollToSection = (e, sectionId) => {
        e.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
            const headerOffset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return ( <
        section className = "hero full-screen" >
        <
        div className = "slider" >
        <
        div className = "slides" > {
            images.map((image, index) => ( <
                div key = { index }
                className = { `slide slide${index + 1}` }
                style = {
                    { backgroundImage: `url(${image})` } } >
                < /div>
            ))
        } <
        /div> <
        div className = "hero-overlay" > < /div> <
        /div>

        <
        div className = "container hero-container" >
        <
        div className = "hero-content" >
        <
        span className = "hero-badge" > CALL CENTER & DEBT RECOVERY < /span> <
        h1 className = "hero-title" >
        Professional Solutions < br / >
        for Business Growth <
        /h1> <
        p className = "hero-description" >
        Reliable, ethical, and results - driven call center services and debt collection solutions that help businesses improve cash flow and strengthen customer relationships. <
        /p> <
        div className = "hero-buttons" >
        <
        a href = "#services"
        className = "btn btn-primary"
        onClick = {
            (e) => scrollToSection(e, 'services') } >
        Our Services→ <
        /a> <
        a href = "#contact"
        className = "btn btn-secondary"
        onClick = {
            (e) => scrollToSection(e, 'contact') } >
        Contact Us <
        /a> <
        /div> <
        /div> <
        /div> <
        /section>
    );
};

export default Hero;